var map = {
	"./config.banbangkhae": 637,
	"./config.banbangkhae.js": 637,
	"./config.bangpra": 638,
	"./config.bangpra.js": 638,
	"./config.chula": 639,
	"./config.chula.js": 639,
	"./config.develop": 640,
	"./config.develop.js": 640,
	"./config.dop": 641,
	"./config.dop-gdcc": 642,
	"./config.dop-gdcc.js": 642,
	"./config.dop.js": 641,
	"./config.localServer": 643,
	"./config.localServer.js": 643,
	"./config.localhost": 644,
	"./config.localhost.js": 644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6356;